export class PMSPartnerClientHinge {
	id: number;
	partnerUserId: number;
	clientId: number;
	clientName: string;
	isActive : boolean;
}

export class PMSPartner {
	id: number;
	partnerName: string;
}

export class PMSPartnerUser {
	id: number;
	firstName: string;
	lastName: string;
	userName: string;
	email: string;
	passwordHash: string;
	tokenTimeout: number;
	phoneNumber: string;
	normalizedUserName: string;
	password: string;
	normalizedEmail: string;
	ecAllowed: boolean;
	acceptedTC: boolean;
	mobilePhone: string;
	createdDate: Date | string;
	pmsPartnerId: number;
	isLocked: boolean;
	pmsPartnerName: string;
	apiVendor : number;
}